import { render, staticRenderFns } from "./SchoolSystemIconPlusDialog.vue?vue&type=template&id=78b707a9&scoped=true"
import script from "./SchoolSystemIconPlusDialog.vue?vue&type=script&lang=js"
export * from "./SchoolSystemIconPlusDialog.vue?vue&type=script&lang=js"
import style0 from "./SchoolSystemIconPlusDialog.vue?vue&type=style&index=0&id=78b707a9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b707a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b707a9')) {
      api.createRecord('78b707a9', component.options)
    } else {
      api.reload('78b707a9', component.options)
    }
    module.hot.accept("./SchoolSystemIconPlusDialog.vue?vue&type=template&id=78b707a9&scoped=true", function () {
      api.rerender('78b707a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SchoolSystemIconPlusDialog.vue"
export default component.exports